import cx from 'classnames'
import { useState } from 'react'

import Styles from './Loader.module.scss'

import { Form } from 'components/Wizards/Form/Form'

export interface LoaderProps {
  icon: React.ReactNode
  text: string
}

export const Loader = ({ icon, text }: LoaderProps) => {
  const [num, setNum] = useState(0)

  setTimeout(() => {
    if (num === 2) {
      setNum(0)
    }
    if (num === 1) {
      setNum(2)
    }
    if (num === 0) {
      setNum(1)
    }
  }, 1000)

  return (
    <Form.Root>
      <Form.Fields className={Styles.container}>
        <div className={Styles.content}>
          {icon}
          <div className={Styles.loadingText}>
            <span>{text}</span>
            <span data-testid="dot-1" className={cx(Styles.dot, { [Styles.visible]: num > 0 })}>
              .
            </span>
            <span data-testid="dot-2" className={cx(Styles.dot, { [Styles.visible]: num > 1 })}>
              .
            </span>
          </div>
        </div>
      </Form.Fields>
    </Form.Root>
  )
}
